export const CFT = {
  ACCOUNTANT_HUB: 'accountant-hub',
  ACCOUNTING_ONBOARDING: 'accounting-onboarding',
  ACCOUNTS_PAYABLE: 'accounts-payable',
  ACCOUNTS_RECEIVABLE: 'accounts-receivable',
  ACCOUNT_SECURITY: 'account-security',
  AI_LAB: 'ai-lab',
  APP_SYSTEMS: 'app-systems',
  CARDS_ACCEPTANCE: 'cards-acceptance',
  CARDS_ISSUING: 'cards-issuing',
  CASH_FLOW_MANAGEMENT: 'cash-flow-management',
  CL_ACCOUNT_MANAGEMENT: 'cl-account-management',
  CL_ACTIVATION: 'cl-activation',
  COMPANY_CREATION: 'company-creation',
  CONNECT: 'connect',
  DIRECT_DEBITS: 'direct-debits',
  DUE_DILIGENCE: 'due-diligence',
  E_INVOICING: 'e-invoicing',
  FINANCING: 'financing',
  IDENTITY_VERIFICATION: 'identity-verification',
  LOCAL_PAYMENTS: 'local-payments',
  PRE_ACCOUNTING: 'pre-accounting',
  PRICING: 'pricing',
  REGISTRATION: 'registration',
  SPEND_MANAGEMENT: 'spend-management',
  TRANSFERS: 'transfers',
} as const;

type CFTKey = keyof typeof CFT;
export type CFTValue = (typeof CFT)[CFTKey];

export const PIPE = {
  ACCOUNTANT_HUB: {},
  ACCOUNTING_ONBOARDING: {},
  ACCOUNTS_PAYABLE: {},
  ACCOUNTS_RECEIVABLE: {},
  ACCOUNT_SECURITY: {},
  AI_LAB: {},
  APP_SYSTEMS: {},
  CARDS_ACCEPTANCE: {},
  CARDS_ISSUING: {},
  CASH_FLOW_MANAGEMENT: {},
  CL_ACCOUNT_MANAGEMENT: {},
  CL_ACTIVATION: {},
  COMPANY_CREATION: {
    de_company_creation: 'de_company_creation',
    de_company_creation_sole_trader: 'de_company_creation_sole_trader',
    de_full_company_creation_companies: 'de_full_company_creation_companies',
    de_full_company_creation_freelancers: 'de_full_company_creation_freelancers',
    de_full_company_creation_gbr: 'de_full_company_creation_gbr',
    es_company_creation: 'es_company_creation',
    fr_company_creation: 'fr_company_creation',
    fr_full_company_creation_with_capital_deposit: 'fr_full_company_creation_with_capital_deposit',
    fr_full_company_creation_without_capital_deposit:
      'fr_full_company_creation_without_capital_deposit',
    it_company_creation: 'it_company_creation',
    nl_company_creation: 'nl_company_creation',
  },
  CONNECT: {},
  DIRECT_DEBITS: {},
  DUE_DILIGENCE: {
    INITIAL: 'initial',
    ONGOING: 'ongoing',
  },
  E_INVOICING: {},
  FINANCING: {},
  IDENTITY_VERIFICATION: {},
  LOCAL_PAYMENTS: {},
  PRE_ACCOUNTING: {},
  PRICING: {},
  REGISTRATION: {},
  SPEND_MANAGEMENT: {},
  TRANSFERS: {},
} as const satisfies Record<CFTKey, Record<string, string>>;

export type CFTPipeValue = {
  [K in CFTKey]: (typeof PIPE)[K][keyof (typeof PIPE)[K]];
}[CFTKey];

export const OWNER = {
  ACCOUNTS_PAYABLE: 'accounts-payable',
  ACCOUNT_SECURITY: 'account-security',
  ACTIVATION: 'activation',
  CARDS_ISSUING: 'cards-issuing',
  CORE_APP_XP: 'core-app-xp',
  CREDIT_FACILITY_PRODUCTS: 'credit_facility_products',
  CUSTOMER_STATUS: 'customer_status',
  DIRECT_DEBITS: 'direct-debits',
  LOCAL_PAYMENTS: 'local-payments',
  PERIODIC_REVIEW_EDD: 'periodic-review-edd',
  SAVINGS_AND_DEPOSITS: 'savings_and_deposits',
  SPEND_MANAGEMENT: 'spend-management',
  TRANSACTIONS: 'transactions',
  TRANSFERS: 'transfers',
  WEALTH_AND_MARKETS: 'wealth_and_markets',
  WORKFLOWS_AND_DELEGATION: 'workflows-and-delegation',
  WORKING_CAPITAL_PRODUCTS: 'working_capital_products',
} as const;

type OWNERKey = keyof typeof OWNER;
export type OWNERValue = (typeof OWNER)[OWNERKey];
